import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCensusSheet = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 2,
			width: 12,
			height: 14,
			rx: 1.5,
			stroke: "currentColor",
			strokeWidth: 1.3
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6,
			y1: 6,
			x2: 12,
			y2: 6,
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6,
			y1: 9,
			x2: 12,
			y2: 9,
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6,
			y1: 12,
			x2: 9.5,
			y2: 12,
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round"
		})
	]
});
export { SvgCensusSheet as ReactComponent };
